let utils = require('./utils');

let charity_nav = ( function( $ ) {

	let $nav,
		$pages_wrapper,
		$pages;

	let _init = function() {
		$nav           = $( '#charity-nav' );
		$pages_wrapper = $( '#charity-pages' );
		$pages         = $pages_wrapper.find( '.page' );

		_initial_reveal();

		$nav.find( 'li.page-link a' ).on( 'click', _setup_nav_link );

		_set_li_heights();

		$( window ).smartresize( function() {
			_set_li_heights();
		} );
	};

	let _setup_nav_link = function( e ) {
		e.preventDefault();

		let $data_page = $( this ).data( 'page' );
		let $page      = $pages_wrapper.find( '.page[data-page="'+ $data_page +'"]' );

		// Don't do anything if already shown
		if ( $page.hasClass( 'displayed' ) ) {
			return;
		}

		window.history.replaceState( null, null, $data_page );

		_reveal_page( $page );
	};

	let _set_li_heights = function() {
		if ( utils.viewport_size().width >= 768 ) {

			let $cols = $nav.find( 'li' ),
				height = 0;

			$cols.css( 'height', 'auto' );

			$cols.each( function( index, item ) {
				if ( $( item ).outerHeight() > height ) {
					height = $( item ).outerHeight();
				}
			} );

			$cols.css( 'height', height );
		} else {
			$nav.find( 'li' ).css( 'height', 'auto' );
		}
	};

	let _highlight_active_menu = function() {
		$nav.find( 'li' ).removeClass( 'active' );

		let active_item       = $pages.filter( '.displayed' ).data( 'page' ),
			$active_menu_item = $nav.find( 'a[data-page="' + active_item + '"]' );

		$active_menu_item.closest( 'li' ).addClass( 'active' );
	};

	let _show_page = function ( $page ) {
		$page.css( { 'display' : 'block' } );
		$page.addClass( 'displayed' );

		_highlight_active_menu()
	};

	let _hide_pages = function () {
		$pages.css( { 'display' : 'none' } );
		$pages.removeClass( 'displayed' );
	};

	let _reveal_page = function ( $page ) {
		_hide_pages();
		_show_page( $page );
	};

	let _initial_reveal = function() {
		let url         = window.location.href;
		let hashtag_pos = url.indexOf( '#' );

		// If url doesn't contain # show first page
		if ( hashtag_pos <= 0 ) {
			// Hide all pages
			_hide_pages();

			// Show the first page
			_show_page( $pages.first() );
		} else {
			let $data_page = url.substr( hashtag_pos );
			let $page      = $pages_wrapper.find( '.page[data-page="' + $data_page + '"]' );

			_reveal_page( $page );
		}
	};

	if ( $( '#charity-pages' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = charity_nav;